import React, { Component } from 'react';
import * as Progress from 'react-native-progress';
import { StyleSheet, Text, View, Platform } from 'react-native';
import { Input, Button } from '../components';

class HomeArticlesList extends Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  render() {

    return (
      <View style={styles.main_container}>
        <View style={styles.content_container}>
          <Text style={styles.category_section_title}>CATEGORY TITLE</Text>
          <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
            <View style={{ height: 100, width: 110, backgroundColor: 'white', borderRadius: 10 }}></View>
            <View style={{ height: 100, width: 110, backgroundColor: 'white', borderRadius: 10 }}></View>
            <View style={{ height: 100, width: 110, backgroundColor: 'white', borderRadius: 10 }}></View>
          </View>
        </View>
      </View>
    );
  }

}

const styles = StyleSheet.create({
  content_container: {

  },
  category_section_title: {
    fontWeight: 'bold',
    fontSize: 16,
    marginBottom: 5,
    fontFamily: 'DMSans-Bold'
  },
  main_container: {

  },
  articles_list_container: {
    flexDirection: 'row',
  }
});

export default HomeArticlesList
